import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calendario-trat',
  templateUrl: './calendario-trat.component.html',
  styleUrls: ['./calendario-trat.component.css']
})
export class CalendarioTratComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
